import logger from '../utils/logger';
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import PageTopBar from './customComponents/PageTopBar';
import { Home, Aperture, FileCheck } from 'lucide-react';
import '../style/Labs.css';
import '../style/PDFResultsModal.css';
import { GlobalStateContext } from "../utils/GlobalStateContext";
import UserDetails from './customComponents/tracker';
import LabResultsWorkflow from './customComponents/LabResultsWorkflow';
import { formatTo12Hour, formatAppointmentDate, formatAppointmentTimeRange, numberedList, getUserId, formatDateOfBirth, capitalize, convertUTCToCentral, dateOfBirth, formatTimePlusFiveHours, sanitizeDateForInput } from '../utils/utils';
import { formatAccession } from '../utils/labAccession';
import AbnormalFlag from './customComponents/AbnormalFlag';
import ResultRowsEditor, { EMPTY_ROW, isCompleteRow } from './customComponents/ResultRowsEditor';
import { InputMask } from '@react-input/mask';
import GearsSpinner from './customComponents/GearsSpinner';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const patientLabSchedule = [

    {
      patientName: 'John Doe',
      scheduleTime: '10:00 AM',
      currentOrNew: 'Current',
      labOrdered: 'Blood Test',
      specimenType: 'Blood',
      location: 'Lab A',
      priorLabs: 'Yes',
      imagingRelated: 'No',
      facility: 'Hospital X',
    },
    {
      patientName: 'Jane Smith',
      scheduleTime: '11:00 AM',
      currentOrNew: 'New',
      labOrdered: 'Urine Test',
      specimenType: 'Urine',
      location: 'Lab B',
      priorLabs: 'No',
      imagingRelated: 'Yes',
      facility: 'Clinic Y',
    },
  ];




  const labOrderStatus = [
    {
      orderReceived: 'Yes',
      patientNameConfirmed: 'Yes',
      specimenTypeConfirmed: 'Yes',
      labsReviewed: 'Yes',
      pocCartridgeReordered: 'No',
    },
    {
      orderReceived: 'No',
      patientNameConfirmed: 'No',
      specimenTypeConfirmed: 'No',
      labsReviewed: 'No',
      pocCartridgeReordered: 'Yes',
    },
  ];

  
// Hardcoded data for initial schedule
const scheduleData = {
    today: [
      { id: 1, patient_name: 'John Doe', sample_type:'Urine', description: 'Liver Panel', time: '2025-04-17 09:00', examId: 101 },
      { id: 2, patient_name: 'Jane Smith', sample_type:'Blood', description:'White Blood Cell Count', time: '2025-04-17 10:30', examId: 102 },
      { id: 3, patient_name: 'Alice Brown', sample_type:'Stool', description:'Thyroid Panel', time: '2025-04-17 13:00', examId: 103 },
    ],
    week: [
      { id: 4, patient_name: 'Bob Johnson', sample_type:'Blood', description: 'Complete Blood Panel', time: '2025-04-18 11:00', examId: 104 },
      { id: 5, patient_name: 'Emma Wilson', sample_type:'Stool', description: 'Complete Stool Panel', time: '2025-04-19 14:00', examId: 105 },
  ],
    month: [
      { id: 6, patient_name: 'Liam Davis', sample_type:'Urine', description: 'Kidney Panel', time: '2025-04-18 11:00', examId: 106 },
      { id: 7, patient_name: 'Olivia Lee', sample_type:'Blood', description: 'Metabolic Panel', time: '2025-04-19 14:00', examId: 107 },
    ],
  };

  // Hardcoded data for exam details
const examDetailsData = {
    101: {
      id: 101,
      patientId: 1001,
      sample_type: 'Urine',
      description: 'Liver Panel to assess liver function',
      priority: 'Routine',
      status: 'Scheduled',
      priorReports: "Yes", 
      priorExams: "Yes",
      studyDate: '2025-04-28',
      facility: 'Facility A',
      billableHistory: 'Yes',
    },
    102: {
      id: 102,
      patientId: 1002,
      sample_type: 'Blood',
      description: 'White Blood Cell Count for infection screening',
      priority: 'STAT',
      status: 'Arrived',
      priorReports: "Yes", 
      priorExams: "Yes",
      studyDate: '2025-04-28',
      facility: 'Facility A',
      billableHistory: 'Yes',
    },
    103: {
      id: 103,
      patientId: 1003,
      sample_type: 'Stool',
      description: 'Thyroid Panel for thyroid function evaluation',
      priority: 'Routine',
      status: 'Scanned',
      priorReports: "Yes", 
      priorExams: "Yes",
      studyDate: '2025-04-28',
      facility: 'Facility A',
      billableHistory: 'Yes',
    },
    104: {
      id: 104,
      patientId: 1004,
      sample_type: 'Blood',
      description: 'Complete Blood Panel for overall health assessment',
      priority: 'Next Day',
      status: 'Transmitting',
      priorReports: "Yes", 
      priorExams: "Yes",
      studyDate: '2025-04-28',
      facility: 'Facility A',
      billableHistory: 'Yes',
    },
    105: {
      id: 105,
      patientId: 1005,
      sample_type: 'Stool',
      description: 'Complete Stool Panel for digestive health',
      priority: 'Trauma',
      status: 'Received',
      priorReports: "Yes", 
      priorExams: "Yes",
      studyDate: '2025-04-28',
      facility: 'Facility A',
      billableHistory: 'Yes',
    },
    106: {
      id: 106,
      patientId: 1006,
      sample_type: 'Urine',
      description: 'Kidney Panel for renal function assessment',
      priority: '2 days',
      status: 'Complete',
      priorReports: "Yes", 
      priorExams: "Yes",
      studyDate: '2025-04-28',
      facility: 'Facility A',
      billableHistory: 'Yes',
    },
    107: {
      id: 107,
      patientId: 1007,
      sample_type: 'Blood',
      description: 'Metabolic Panel for metabolic function',
      priority: 'Routine',
      status: 'Scheduled',
      priorReports: "No", 
      priorExams: "Yes",
      studyDate: '2025-04-28',
      facility: 'Facility A',
      billableHistory: 'Yes',
    },
  };
  // Hardcoded data for prior reports and images
  const priorReportsData = {
    1001: [
      { id: 301, date: '2024-01-16', sample_type: 'Blood', description: 'Complete Blood Count', status: 'Completed' },
      { id: 302, date: '2023-06-21', sample_type: 'Urine', description: 'Urinalysis', status: 'Completed' },
    ],
    1002: [
      { id: 303, date: '2024-02-10', sample_type: 'Stool', description: 'Stool Culture', status: 'Completed' },
    ],
    1003: [
      { id: 304, date: '2023-12-05', sample_type: 'Blood', description: 'Liver Function Test', status: 'Completed' },
    ],
    1004: [],
    1005: [
      { id: 305, date: '2024-03-15', sample_type: 'Urine', description: 'Kidney Function Test', status: 'Completed' },
    ],
    1006: [
      { id: 306, date: '2023-11-20', sample_type: 'Blood', description: 'Thyroid Panel', status: 'Completed' },
    ],
    1007: [],
  };
  
  //dropdown list of options to select from for priority and status
  const priorities = ['Routine', 'STAT', 'Stroke', 'Trauma', 'Next Day', '2 days'];
  const statuses = ['scheduled', 'arrived', 'scanned', 'transmitting', 'received', 'complete', 'cancelled'];

  
  
  // Adding Rad Patient Checklist Component
  const RadPatientChecklist = ({id}) => {
    const [labOrders, setLabOrders] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const {currentUser} = useContext(GlobalStateContext);
    const user = getUserId(currentUser);

    const [checklistData, setChecklistData] = useState([
        {
            order_received: true,
            authorization_received: false,
            name_confirmed: false,
            labs_reviewed: false,
            latex_allergy: false,
            contrast_reviewed: false,
            consent_reviewed: false,
            poc_reordered: false
        },
    ]);

    const handleChecklistChange = (rowIndex, field, value) => {
        const newData = [...checklistData];
        newData[rowIndex][field] = value;
        setChecklistData(newData);
    };
    const BASE_URL = process.env.REACT_APP_API_URL;


     //get checklist information
    useEffect(() => {
      const fetchChecklist = async () => {
        try {
            // logger.log("ID: " + id)
            const response = await fetch(`${BASE_URL}/orders/labChecklist?id=${id}&user=${user}&type=${currentUser.type}`);
            if (response.ok) {
            const data = await response.json();
            // logger.log("Lab checklist: " + JSON.stringify(data));
            setChecklistData(data);
            }
        } catch (error) {
            logger.error("Error fetching radiology orders", error);
        }
      }

      fetchChecklist();
    }, [id])
    //save checklist information
const saveChecklist = async (checklistData) => {

  if (isEditing) {
    try {
      const response = await fetch(`${BASE_URL}/orders/labChecklist`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ checklistData: checklistData[0], id, user, type: currentUser.type }),
      });
      if (response.ok) {
        const data = await response.json();
        // logger.log("Radiology checklist: " + JSON.stringify(data));
        // Optionally update state here
      }
    } catch (error) {
      logger.error("Error updating radiology checklist", error);
    }
  }

  setIsEditing(!isEditing); // Toggle after save
};

    return (
        <div>
            
            <h3>Patient Checklist</h3>
            <button onClick={() =>  saveChecklist(checklistData)} className="ris-little-blue-button">
                {isEditing ? 'Done' : 'Edit'}
            </button>
            <div className='ris-lab-grid2'>
                <h4>Order Received</h4>
                <h4>Authorization Received</h4>
                <h4>Patient Name Confirmed</h4>
                <h4>Labs Reviewed</h4>
                <h4>Latex Allergy</h4>
                <h4>Contrast Protocol Reviewed</h4>
                <h4>Consent Reviewed</h4>
                <h4>POC Cartridge Reordered</h4>
            </div>
            {checklistData.map((row, index) => (
                <div key={index} className='ris-lab-grid2'>
                    <p>{isEditing ? <input type="checkbox" checked={row.order_received} onChange={(e) => handleChecklistChange(index, 'order_received', e.target.checked)} /> : (row.order_received ? 'Yes' : 'No')}</p>
                    <p>{isEditing ? <input type="checkbox" checked={row.authorization_received} onChange={(e) => handleChecklistChange(index, 'authorization_received', e.target.checked)} /> : (row.authorization_received ? 'Yes' : 'No')}</p>
                    <p>{isEditing ? <input type="checkbox" checked={row.name_confirmed} onChange={(e) => handleChecklistChange(index, 'name_confirmed', e.target.checked)} /> : (row.name_confirmed ? 'Yes' : 'No')}</p>
                    <p>{isEditing ? <input type="checkbox" checked={row.labs_reviewed} onChange={(e) => handleChecklistChange(index, 'labs_reviewed', e.target.checked)} /> : (row.labs_reviewed ? 'Yes' : 'No')}</p>
                    <p>{isEditing ? <input type="checkbox" checked={row.latex_allergy} onChange={(e) => handleChecklistChange(index, 'latex_allergy', e.target.checked)} /> : (row.latex_allergy ? 'Yes' : 'No')}</p>
                    <p>{isEditing ? <input type="checkbox" checked={row.contrast_reviewed} onChange={(e) => handleChecklistChange(index, 'contrast_reviewed', e.target.checked)} /> : (row.contrast_reviewed ? 'Yes' : 'No')}</p>
                    <p>{isEditing ? <input type="checkbox" checked={row.consent_reviewed} onChange={(e) => handleChecklistChange(index, 'consent_reviewed', e.target.checked)} /> : (row.consent_reviewed ? 'Yes' : 'No')}</p>
                    <p>{isEditing ? <input type="checkbox" checked={row.poc_reordered} onChange={(e) => handleChecklistChange(index, 'poc_reordered', e.target.checked)} /> : (row.poc_reordered ? 'Yes' : 'No')}</p>
              </div>
            ))}
        </div>
    );
};
  const ExamStatus = ({ onSelectExam }) => {
    const [examStatus, setExamStatus] = useState([]);
    const {currentPatient, setCurrentPatient} = useContext(GlobalStateContext);
    const BASE_URL = process.env.REACT_APP_API_URL;
    const {currentUser} = useContext(GlobalStateContext);
    const user = getUserId(currentUser);
    
    useEffect (() => {
      const fetchExamStatus = async () => {
        try {
              const response = await fetch(`${BASE_URL}/orders/labExamStatus?user=${user}&type=${currentUser.type}`);
              if (response.ok) {
              const data = await response.json();
              setExamStatus(data);
              }
          } catch (error) {
              logger.error("Error fetching radiology orders", error);
          }
      }

      fetchExamStatus();
    }, [])
    return (
      <div className="ris-radiology-exam-status">
        <h3 className="ris-section-title">Active Exams</h3>
        <table className="ris-radiology-table">
          <thead>
            <tr>
              <th>Accession</th>
              <th>Patient</th>
              <th>Scheduled Time</th>
              <th>Specimen Type</th>
              <th>Description</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>

            {examStatus.map((exam) => (
              <tr key={exam.id} onClick={() => {onSelectExam(exam.id); setCurrentPatient({ris_patients_id: exam.ris_patients_id, first_name: exam.first_name, last_name: exam.last_name});}}>
                <td><AccessionTag type="lab" id={exam.id} /></td>
                <td>{exam.first_name + " "+ exam.last_name}</td>
                <td>{exam.appointment_start ? formatAppointmentDate(exam.appointment_start) + ' ' + formatAppointmentTimeRange(exam.appointment_start, exam.appointment_end) : 'N/A'}</td>
                <td>{exam.specimen_type}</td>
                <td>
                  {exam.exam_ordered}
                  <AbnormalFlag status={exam.abnormal_status} abnormal={exam.abnormal} />
                </td>
                <td>{exam.status.charAt(0).toUpperCase() + exam.status.slice(1)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

const Schedule = ({ onSelectExam }) => {
  const [view, setView] = useState('today');
  const {currentPatient, setCurrentPatient} = useContext(GlobalStateContext);
  const BASE_URL = process.env.REACT_APP_API_URL;
  // const currentSchedule = scheduleData[view] || [];
  const [table1Data] = useState(patientLabSchedule);
  const [currentSchedule, setCurrentSchedule] = useState([]);
  const {currentUser} = useContext(GlobalStateContext);
  const user = getUserId(currentUser);

  useEffect(() => {
    const fetchcurrentSchedule = async () => {
      try {
            const response = await fetch(`${BASE_URL}/orders/labTodayCurrentSchedule?user=${user}&type=${currentUser.type}`);
            if (response.ok) {
            const data = await response.json();
            // logger.log('schedule data: ', data)
            setCurrentSchedule(data);
            }
        } catch (error) {
            logger.error("Error fetching lab orders", error);
        }
    }

    fetchcurrentSchedule();
  }, [])

  const handleSchedule = async (range) => {
    switch(range) {
      case "today":
        setCurrentSchedule([]);
         try {
            const response = await fetch(`${BASE_URL}/orders/labTodayCurrentSchedule?user=${user}&type=${currentUser.type}`);
            if (response.ok) {
            const data = await response.json();
            setCurrentSchedule(data);
            }
        } catch (error) {
            logger.error("Error fetching today's lab orders", error);
        }
        break;
      case "week":
        setCurrentSchedule([]);
        try {
            const response = await fetch(`${BASE_URL}/orders/labWeekCurrentSchedule?user=${user}&type=${currentUser.type}`);
            if (response.ok) {
            const data = await response.json();
            setCurrentSchedule(data);
            }
        } catch (error) {
            logger.error("Error fetching this week's lab orders", error);
        }
        break;
      case "month":
        setCurrentSchedule([]);
        try {
            const response = await fetch(`${BASE_URL}/orders/labMonthCurrentSchedule?user=${user}&type=${currentUser.type}`);
            if (response.ok) {
            const data = await response.json();
            setCurrentSchedule(data);
            }
        } catch (error) {
            logger.error("Error fetching this month's lab orders", error);
        }
        break;
      default:
        logger.log("No matching case")
    }
  }

  return (
    
    <div className="ris-radiology-schedule">
      {/* new add */}
      
      <div className="ris-radiology-subtabs">
        <button
          className={view === 'today' ? 'active' : ''}
          onClick={() => {setView('today'); handleSchedule('today');}}
        >
          Today
        </button>
        <button
          className={view === 'week' ? 'active' : ''}
          onClick={() => {setView('week'); handleSchedule('week');}}
        >
          Week
        </button>
        <button
          className={view === 'month' ? 'active' : ''}
          onClick={() => {setView('month'); handleSchedule('month');}}
        >
          Month
        </button>
      </div>
      <h3 className="ris-section-title">Schedule for {view.charAt(0).toUpperCase() + view.slice(1)}:</h3>
      {currentSchedule.length > 0 ? (
        <ul>
          {currentSchedule.map((appt) => (
                <li key={appt.id} onClick={() => {onSelectExam(appt.id); setCurrentPatient({ris_patients_id: appt.ris_patients_id, first_name: appt.first_name, last_name: appt.last_name})}} className='ris-lab-schedule-item'>
                {appt.first_name} {appt.last_name} - {appt.specimen_type} - {appt.exam_ordered + " |"} {formatAppointmentDate(appt.appointment_start) + " from " + formatAppointmentTimeRange(appt.appointment_start, appt.appointment_end)}
                </li>
          ))}
        </ul>
        ) : (
            <p>No appointments scheduled for this period.</p>
          )}
        <div>
        </div>
        
        <h3>Patient Lab Schedule</h3>
        <div className="ris-lab-table-container">
          <table className="ris-lab-table">
            <thead>
              <tr>
                <th>Patient Name</th>
                <th>Schedule Time</th>
                <th>Current or New Patient</th>
                <th>Specimen Type</th>
                <th>Lab Ordered</th>
                <th>Location</th>
                <th>Prior Labs</th>
                <th>Imaging Related</th>
                <th>Facility</th>
              </tr>
            </thead>
            <tbody>
              {currentSchedule.map((row, index) => (
                <tr key={index}>
                  <td>
                      {row.first_name} {row.last_name}                   
                  </td>
                  <td>
                      {formatAppointmentDate(row.appointment_start)} {" at "}
                      {formatAppointmentTimeRange(row.appointment_start, row.appointment_end)}
                  </td>
                  <td>
                       {"Current"} {/*current or new patient */}
                  </td>
                  <td>
                      {row.specimen_type}
                  </td>
                  <td>
                      {row.exam_ordered}
                  </td>
                  <td>
                      {"Lab"} {/*current or new patient */}
                  </td>
                  <td>
                      {"No"}
                  </td>
                  <td>
                      {row.imaging_related ? "Yes" : "No"}
                  </td>
                  <td>
                      {"Health Guardian"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        </div>
        );
      };

const ExamDetail = ({ examId, onBack }) => {
  const [subTab, setSubTab] = useState('information');
  const [examDetails, setExamDetails] = useState([]);
  const [priority, setPriority] = useState(examDetails.priority || 'Routine');
  const [status, setStatus] = useState(examDetails.status || 'scheduled');
  const [specimenCollectedDate, setSpecimenCollectedDate] = useState('');
  const [specimenCollectedTime, setSpecimenCollectedTime] = useState('');
  const [drawnBy, setDrawnBy] = useState('');
  const [fasting, setFasting] = useState('');
  const [table2Data, setTable2Data] = useState(labOrderStatus);
  const [isEditing, setIsEditing] = useState(false);
  const { currentPatient } = useContext(GlobalStateContext);
  const [examSummaries, setExamSummaries] = useState([]);
  const BASE_URL = process.env.REACT_APP_API_URL;
  const {currentUser} = useContext(GlobalStateContext);
  const user = getUserId(currentUser);
  const navigate = useNavigate();

  const handlePriorityChange = (e) => {
    const newPriority = e.target.value;
    setPriority(newPriority);
    logger.log(`Priority for exam ${examId} updated to ${newPriority}`);
    // TODO: Update backend API
  };

  const handleStatusChange = (e) => {
    const newStatus = e.target.value;
    setStatus(newStatus);
    logger.log(`Status for exam ${examId} updated to ${newStatus}`);
    // TODO: Update backend API
  };

  const handleImagesChange = (e) => {
    const newImages = parseInt(e.target.value, 10) || 0;
    setNumberOfImages(newImages);
    logger.log(`Number of images for exam ${examId} updated to ${newImages}`);
    // TODO: Update backend API
  };

  const savePatchData = async () => {
    try {
      // logger.log(examId)
        const response = await fetch(`${BASE_URL}/orders/labExamDetails`, 
          { // Ensure this endpoint exists in your backend  
            method: 'PATCH',
            headers: {
          'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                priority, status,
                specimen_collected_date: specimenCollectedDate || null,
                specimen_collected_time: specimenCollectedTime || null,
                specimen_collected_by: drawnBy || null,
                fasting: fasting || null,
                lab_orders_id: examId, user, type: currentUser.type, id: currentPatient.ris_patients_id})
            });

        if (!response.ok) {
            throw new Error(`Failed to update exam details: ${response.statusText}`);
        }

        logger.log('Radiology exam details updated successfully');
        toast.success('Exam information changed successfully');
    } catch (error) {
        logger.error('Error updating exam details ', error);
        toast.error('Failed to change exam information');
    }
  };

  const returnToWorklist = async () => {
    if (!window.confirm('Return this order to the worklist? This will unlink it from its scheduled appointment.')) return;
    try {
      const response = await fetch(`${BASE_URL}/orders/returnToWorklist`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ order_id: examId, order_type: 'lab', user, type: currentUser.type }),
      });
      if (!response.ok) throw new Error('Failed to return order to worklist');
      navigate('/orderworklist');
    } catch (error) {
      logger.error('Error returning order to worklist:', error);
    }
  };

    useEffect(() => {
    // logger.log('useEffect triggered with examId:', examId, 'currentPatient:', currentPatient);

    if (!currentPatient?.ris_patients_id) return;

    // Skip fetch if examId is not defined
    if (!examId) {
      logger.warn('examId is undefined, skipping fetch');
      setExamDetails(null);
      return;
    }

    const fetchExamDetails = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/orders/labExamDetails?id=${examId}&user=${user}&type=${currentUser.type}`
        );
        if (response.ok) {
          const data = await response.json();
          setExamDetails(data[0]);
          setPriority(data[0].priority)
          setStatus(data[0].status)
          setSpecimenCollectedDate(data[0].specimen_collected_date ? sanitizeDateForInput(data[0].specimen_collected_date) : '');
          // Auto-fill collection details: use stored values, else default time = now
          // and drawn-by = the logged-in user (all remain editable before saving).
          setSpecimenCollectedTime(data[0].specimen_collected_time ? String(data[0].specimen_collected_time).slice(0, 5) : new Date().toTimeString().slice(0, 5));
          setDrawnBy(data[0].specimen_collected_by || `${currentUser.first_name || ''} ${currentUser.last_name || ''}`.trim());
          setFasting(data[0].fasting || '');
        }
      } catch (error) {
        logger.error('Error fetching Radiology orders:', error);
      }
    };
    fetchExamDetails();
  }, [])

    const fetchExamSummaries = async () => {
    try {
        const response = await fetch(
          `${BASE_URL}/orders/labPatientSummary?id=${currentPatient.ris_patients_id}&user=${user}&type=${currentUser.type}`
        );
        if (response.ok) {
          const data = await response.json();
          setExamSummaries(data);
        }
      } catch (error) {
        logger.error('Error fetching Radiology orders:', error);
      }
  }

  return (
    <div className="ris-radiology-exam-detail">
      <button onClick={onBack} className='ris-radiology-back-button'>Back to List</button>
      <div className="ris-radiology-subtabs">
        <button
          className={subTab === 'information' ? 'active' : ''}
          onClick={() => setSubTab('information')}
        >
          Exam Information
        </button>
        <button
          className={subTab === 'reports' ? 'active' : ''}
          onClick={() => setSubTab('reports')}
        >
          Prior Reports
        </button>
        <button
          className={subTab === 'checklist' ? 'active' : ''}
          onClick={() => setSubTab('checklist')}
        >
          Patient Checklist
        </button>
        <button
          className={subTab === 'status' ? 'active' : ''}
          onClick={() => {setSubTab('status'); fetchExamSummaries();}}
        >
          Patient Summary
        </button>
        <button
          className={subTab === 'results' ? 'active' : ''}
          onClick={() => setSubTab('results')}
        >
          Results
        </button>
      </div>
      <div>
        <UserDetails/> 
      </div>
      {subTab === 'information' && (
        <div className="ris-radiology-exam-info">
          <h3>
            Exam Information
            <AbnormalFlag status={examDetails.abnormal_status} abnormal={examDetails.abnormal} />
          </h3>
          <div className="ris-radiology-form-group">
            <label>Accession:</label>
            {examDetails.id ? <AccessionTag type="lab" id={examDetails.id} /> : <span>N/A</span>}
          </div>
          <div className="ris-radiology-form-group">
            <label>Order ID:</label>
            <span>{examDetails.id || 'N/A'}</span>
          </div>
          <div className="ris-radiology-form-group">
            <label>Specimen Type:</label>
            <span>{examDetails.specimen_type || 'N/A'}</span>
          </div>
          <div className="ris-radiology-form-group">
            <label>Exam Ordered:</label>
            <span>{examDetails.exam_ordered || 'N/A'}</span>
          </div>
          <div className="ris-radiology-form-group">
            <label>CPT Code:</label>
            <span>{examDetails.cpt_code || 'N/A'}</span>
          </div>
          <div className="ris-radiology-form-group">
            <label>Clinical History:</label>
            <span>{examDetails.clinical_history || 'N/A'}</span>
          </div>
          <div className="ris-radiology-form-group">
            <label>Notes:</label>
            <span>{examDetails.notes || 'N/A'}</span>
          </div>
          <div className="ris-radiology-form-group">
            <label>Additional Options:</label>
            <span>{numberedList(examDetails.additional_options) || 'N/A'}</span>
          </div>
          

          <div className="ris-radiology-form-group">
            <label>Status:</label>
            <select value={status} onChange={handleStatusChange}>
              {statuses.map((s) => (
                <option key={s} value={s}>
                  {s.charAt(0).toUpperCase() + s.slice(1)}
                </option>
              ))}
            </select>
          </div>
          <div className="ris-radiology-form-group">
            <label>Priority:</label>
            <select value={priority} onChange={handlePriorityChange}>
              {priorities.map((p) => (
                <option key={p} value={p}>{p}</option>
              ))}
            </select>
          </div>
          <div className="ris-radiology-form-group">
            <label>Date of Service:</label>
            <input
              type="date"
              value={specimenCollectedDate}
              onChange={(e) => setSpecimenCollectedDate(e.target.value)}
            />
          </div>
          <div className="ris-radiology-form-group">
            <label>Specimen Time:</label>
            <input
              type="time"
              value={specimenCollectedTime}
              onChange={(e) => setSpecimenCollectedTime(e.target.value)}
            />
          </div>
          <div className="ris-radiology-form-group">
            <label>Drawn By:</label>
            <input
              type="text"
              value={drawnBy}
              onChange={(e) => setDrawnBy(e.target.value)}
            />
          </div>
          <div className="ris-radiology-form-group">
            <label>Fasting:</label>
            <select value={fasting} onChange={(e) => setFasting(e.target.value)}>
              <option value="">N/A</option>
              <option value="YES">Yes</option>
              <option value="NO">No</option>
            </select>
          </div>

          <div className="ris-detail-actions">
            <button className='ris-bigger-blue-button' onClick={() => savePatchData()}>Save</button>
            <button
              className="ris-worklist-button"
              onClick={returnToWorklist}
            >
              Return to Worklist
            </button>
          </div>
        </div>
      )}
      {subTab === 'reports' && <PriorReports patientId={currentPatient.ris_patients_id} />}
      {subTab === 'images' && <PriorImages patientId={currentPatient.ris_patients_id} />}
      {subTab === 'checklist' && <RadPatientChecklist id={examDetails.id} />}
      {subTab === 'status' && (
        
        <div>
        <h3>Patient Summary</h3>
        <div className="ris-lab-table-container">
        {/* <button onClick={() => setIsEditing(!isEditing)}
            className="ris-little-blue-button">
              {isEditing ? 'Done' : 'Edit'}
            </button> */}
          <table className="ris-lab-table">
            <thead>
              <tr>
                <th>Study Date</th>
                <th>Specimen Type</th>
                <th>Exam Description</th>
                <th>Status</th>
                <th>Priority</th>
                <th>Billable History</th>
                <th>Prior Reports</th>
                <th>Facility</th>
              </tr>
            </thead>
            <tbody>
              {examSummaries.map((row, index) => (
                <tr key={index}>
                  <td>
                    {/* {isEditing ? (
                      <input
                        value={row.order_received}
                        onChange={(e) => handleTable2Change(index, 'orderReceived', e.target.value)}
                      />
                    ) : ( */}
                      {formatAppointmentDate(row.appointment_start) || 'No time'}
                    {/* )} */}
                  </td>
                  <td>
                    {/* {isEditing ? (
                      <input
                        value={row.patientNameConfirmed}
                        onChange={(e) => handleTable2Change(index, 'patientNameConfirmed', e.target.value)}
                      />
                    ) : ( */}
                      {row.specimen_type || 'No type'}
                    {/* )} */}
                  </td>
                  <td>
                    {/* {isEditing ? (
                      <input
                        value={row.specimenTypeConfirmed}
                        onChange={(e) => handleTable2Change(index, 'specimenTypeConfirmed', e.target.value)}
                      />
                    ) : ( */}
                      {row.exam_ordered || 'No exam'}
                    {/* )} */}
                  </td>
                  <td>
                    {/* {isEditing ? (
                      <input
                        value={row.labsReviewed}
                        onChange={(e) => handleTable2Change(index, 'labsReviewed', e.target.value)}
                      />
                    ) : ( */}
                      {capitalize(row.status) || 'No status'}
                    {/* )} */}
                  </td>
                  <td>
                    {/* {isEditing ? (
                      <input
                        value={row.pocCartridgeReordered}
                        onChange={(e) => handleTable2Change(index, 'pocCartridgeReordered', e.target.value)}
                      />
                    ) : ( */}
                      {capitalize(row.priority) || 'No priority'}
                    {/* )} */}
                  </td>
                  <td>
                    {row.clinical_history || 'No history'}
                  </td>
                  <td>
                    {row.prior_reports || 'No prior'}
                  </td>
                  <td>
                    {row.facility || 'Health Guardian'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* ))} */}
  </div>)}
      {subTab === 'results' && (
        <div style={{ marginTop: '12px' }}>
          <h3>Lab Results</h3>
          {examDetails.id ? (
            <LabResultsWorkflow
              orderId={examDetails.id}
              cptCode={examDetails.cpt_code}
              examName={examDetails.exam_ordered}
              patient={currentPatient}
              initialResultsPdfPath={examDetails.results_pdf_path}
              initialValidatedAt={examDetails.validated_at}
            />
          ) : (
            <p>Loading lab order…</p>
          )}
        </div>
      )}
    </div>
  );
};
const PriorReports = ({ patientId }) => {
  const [reports, setReports] = useState([]);
  const BASE_URL = process.env.REACT_APP_API_URL;
  const {currentUser} = useContext(GlobalStateContext);
  const user = getUserId(currentUser);

  useEffect(() => {
    // logger.log('useEffect triggered with patientId:', patientId);

    // Skip fetch if examId is not defined
    if (!patientId) {
      logger.warn('patientId is undefined, skipping fetch');
      setReports(null);
      return;
    }

    const fetchReports = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/orders/labReports?id=${patientId}&user=${user}&type=${currentUser.type}`
        );
        if (response.ok) {
          const data = await response.json();
          setReports(data);
        }
      } catch (error) {
        logger.error('Error fetching Lab orders:', error);
      }
    };
    fetchReports();
  }, [patientId])

    return (
      <div className="ris-radiology-prior-reports">
        <h3>Prior Reports</h3>
        {!reports?.length ? (
          <p>No prior reports available.</p>
          ) : (
          <>
          <div className='ris-lab-grid3'>
              <h4>Date</h4>
              <h4>Sample Type</h4>
              <h4>Test Description</h4>
              <h4>Status</h4>
          </div>
          {reports.map((report) => (
              <div key={report.id} className='ris-radiology-grid'>
                  <p>{report.appointment_start ? formatAppointmentDate(report.appointment_start) : 'N/A'}</p>
                  <p>{report.specimen_type ? report.specimen_type : "N/A"}</p>
                  <p>{report.exam_ordered ? report.exam_ordered : "N/A"}</p>
                  <p>{report.status ? capitalize(report.status) : "N/A"}</p>
                  </div>
              ))}
            </>
          )}
        </div>
      );
    };
      
const STATUS_LABELS = {
  pending: 'Pending',
  sent: 'Sent',
  results_received: 'Results Received',
  cancelled: 'Cancelled',
};

const STATUS_COLORS = {
  pending: '#f59e0b',
  sent: '#3b82f6',
  results_received: '#10b981',
  cancelled: '#ef4444',
};

// The accession the lab tech keys into the analyzer by hand. Rendered monospace and
// visually grouped (letter · id · check digit) so it is easy to read off and type,
// and includes the namespace + Damm check digit that a bare order id lacks.
const AccessionTag = ({ type, id, style }) => {
  const acc = formatAccession(type, id);
  if (!acc) return <span>N/A</span>;
  const letter = acc[0];
  const idPart = acc.slice(1, -1);
  const check  = acc.slice(-1);
  return (
    <span
      title="Accession — key this into the analyzer's Sample ID field"
      style={{
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
        fontWeight: 700, letterSpacing: '0.05em', ...style,
      }}
    >
      {letter}&thinsp;{idPart}&thinsp;{check}
    </span>
  );
};

const ReferralList = ({ onSelectReferral }) => {
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(true);
  const BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchReferrals = async () => {
      try {
        const response = await fetch(`${BASE_URL}/labs/referrals`);
        if (response.ok) {
          const data = await response.json();
          setReferrals(data);
        }
      } catch (error) {
        logger.error('Error fetching lab referrals:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchReferrals();
  }, []);

  if (loading) return <p className="ris-section-title">Loading referrals…</p>;

  return (
    <div className="ris-radiology-exam-status">
      <h3 className="ris-section-title">Lab Referral Orders</h3>
      {referrals.length === 0 ? (
        <p>No referral orders found.</p>
      ) : (
        <table className="ris-radiology-table">
          <thead>
            <tr>
              <th>Accession</th>
              <th>Patient</th>
              <th>DOB</th>
              <th>Ordering Clinician</th>
              <th>Diagnosis</th>
              <th>Tests Ordered</th>
              <th>Specimen Date</th>
              <th>Priority</th>
              <th>Status</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            {referrals.map((r) => (
              <tr key={r.id} onClick={() => onSelectReferral(r.id)} style={{ cursor: 'pointer' }}>
                <td><AccessionTag type="referral" id={r.id} /></td>
                <td>{r.first_name} {r.last_name}</td>
                <td>{r.dob || 'N/A'}</td>
                <td>{r.ordering_clinician}</td>
                <td>{r.diagnosis}</td>
                <td>
                  {r.ordered_tests || 'N/A'}
                  <AbnormalFlag status={r.abnormal_status} abnormal={r.abnormal} />
                </td>
                <td>{r.specimen_date ? formatAppointmentDate(r.specimen_date) : 'N/A'}</td>
                <td>
                  <span style={{ color: r.priority === 'STAT' ? '#ef4444' : '#374151', fontWeight: r.priority === 'STAT' ? 700 : 400 }}>
                    {r.priority}
                  </span>
                </td>
                <td className="ris-referral-status-cell">
                  <span className="ris-referral-status-badge" style={{ background: STATUS_COLORS[r.status] || '#6b7280' }}>
                    {STATUS_LABELS[r.status] || r.status}
                  </span>
                </td>
                <td>{formatAppointmentDate(r.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

const ReferralDetail = ({ referralId, onBack }) => {
  const [referral, setReferral] = useState(null);
  const [status, setStatus] = useState('');
  const [saving, setSaving] = useState(false);
  // Structured analyte rows — posted as result_rows so a referral report matches the
  // analyzer report and its values run through the same abnormal evaluation.
  const [resultRows, setResultRows] = useState([{ ...EMPTY_ROW }]);
  const [generating, setGenerating] = useState(false);
  const [generateMsg, setGenerateMsg] = useState('');
  // Re-opens the entry form over a referral that already has a report on file, so a
  // wrong or superseded report can be replaced without losing the one on file first.
  const [replacing, setReplacing] = useState(false);
  const [referralRanges, setReferralRanges] = useState({});
  const [checkedRanges, setCheckedRanges] = useState({});
  const [reportModal, setReportModal] = useState(false);
  const [reportPdfUrl, setReportPdfUrl] = useState(null);
  const [reportLoading, setReportLoading] = useState(false);
  const [faxModal, setFaxModal] = useState(false);
  const [faxNumber, setFaxNumber] = useState('');
  const [validationModal, setValidationModal] = useState(false);
  const [validationLoading, setValidationLoading] = useState(false);
  const [validationResult, setValidationResult] = useState(null);
  const [validationError, setValidationError] = useState(null);
  const BASE_URL = process.env.REACT_APP_API_URL;

  const fetchReferral = async () => {
    try {
      const response = await fetch(`${BASE_URL}/labs/referral/${referralId}`);
      if (response.ok) {
        const data = await response.json();
        setReferral(data);
        setStatus(data.status);
      }
    } catch (error) {
      logger.error('Error fetching referral detail:', error);
    }
  };

  // Reset the entry state whenever the parent swaps to a different referral.
  useEffect(() => {
    setReplacing(false);
    setResultRows([{ ...EMPTY_ROW }]);
    setGenerateMsg('');
    fetchReferral();
  }, [referralId]); // eslint-disable-line

  // Fetch reference ranges once items are loaded. Items carrying a CPT resolve by
  // code; items with NO CPT (hand-keyed referrals often have none) fall back to their
  // name. Names are sent only for those uncoded items on purpose — running a name
  // that already has a CPT through the alias matcher can attach a SECOND, unordered
  // range: a BMP (80048) labeled "Kidney check" also matches the renal-panel alias
  // (80069). A wrong range on a report is worse than no range.
  useEffect(() => {
    if (!referral?.items) return;
    const codes = [...new Set(referral.items.map(i => i.cpt_code).filter(Boolean))];
    const names = [...new Set(referral.items.filter(i => !i.cpt_code && i.item_name).map(i => i.item_name))];
    if (codes.length === 0 && names.length === 0) return;
    const params = new URLSearchParams();
    if (codes.length) params.set('codes', codes.join(','));
    names.forEach(n => params.append('names', n));
    fetch(`${BASE_URL}/labs/reference-ranges?${params.toString()}`)
      .then(r => r.json())
      .then(ranges => {
        setReferralRanges(ranges);
        const checked = {};
        for (const [code, ref] of Object.entries(ranges)) {
          if (ref.rows) ref.rows.forEach((_, idx) => { checked[`${code}_${idx}`] = true; });
        }
        setCheckedRanges(checked);
      })
      .catch(err => logger.error('Error fetching reference ranges:', err));
  }, [referral?.id]); // eslint-disable-line

  const saveStatus = async () => {
    setSaving(true);
    try {
      const response = await fetch(`${BASE_URL}/labs/referral/${referralId}/status`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ status }),
      });
      if (!response.ok) throw new Error('Failed to update status');
      setReferral(prev => ({ ...prev, status }));
    } catch (error) {
      logger.error('Error updating referral status:', error);
    } finally {
      setSaving(false);
    }
  };

  const toggleCheck = (code, idx) => {
    const key = `${code}_${idx}`;
    setCheckedRanges(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const buildSelectedRanges = () => {
    if (!referral?.items) return [];
    const result = [];
    const seen = new Set();
    for (const item of referral.items) {
      if (!item.cpt_code || seen.has(item.cpt_code)) continue;
      seen.add(item.cpt_code);
      const ref = referralRanges[item.cpt_code];
      if (!ref || !ref.rows) continue;
      const checkedRows = ref.rows.filter((_, idx) => checkedRanges[`${item.cpt_code}_${idx}`]);
      if (checkedRows.length === 0) continue;
      result.push({ cpt_code: item.cpt_code, name: ref.name, unit: ref.unit || null, rows: checkedRows, note: ref.note || null });
    }
    return result;
  };

  const filledRows = resultRows.filter(isCompleteRow);

  const generateReport = async () => {
    if (filledRows.length === 0) return;
    setGenerating(true);
    setGenerateMsg('');
    try {
      const response = await fetch(`${BASE_URL}/labs/referral/${referralId}/results`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ result_rows: filledRows, selected_ranges: buildSelectedRanges() }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.msg || 'Failed to generate report');
      setGenerateMsg(
        data.abnormalStatus === 'abnormal'
          ? 'Report generated — ABNORMAL result flagged.'
          : 'Report generated successfully.'
      );
      setResultRows([{ ...EMPTY_ROW }]);
      setReplacing(false);
      await fetchReferral();
    } catch (error) {
      logger.error('Error generating lab results:', error);
      setGenerateMsg(`Error: ${error.message}`);
    } finally {
      setGenerating(false);
    }
  };

  const runValidation = async (manual = false) => {
    setValidationLoading(true);
    setValidationError(null);
    setValidationResult(null);
    try {
      const response = await fetch(`${BASE_URL}/labs/referral/${referralId}/validate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ manual }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.msg || 'Validation failed');
      setValidationResult(data.validationResult);
      // Only unlock fax if validation actually passed
      if (data.validated_at) {
        setReferral(prev => ({ ...prev, validated_at: data.validated_at }));
      }
    } catch (err) {
      logger.error('Validation error:', err);
      setValidationError(err.message);
    } finally {
      setValidationLoading(false);
    }
  };

  const openReportModal = async () => {
    if (!referral?.results_pdf_path) return;
    setReportLoading(true);
    setReportPdfUrl(null);
    setReportModal(true);
    try {
      const response = await fetch(`${BASE_URL}/upload/generate-signed-url?pdfName=${encodeURIComponent(referral.results_pdf_path)}`);
      const data = await response.json();
      if (data.signedUrl) setReportPdfUrl(data.signedUrl);
    } catch (error) {
      logger.error('Error generating signed URL:', error);
    } finally {
      setReportLoading(false);
    }
  };

  if (!referral) return <p style={{ padding: '20px' }}>Loading…</p>;

  const profiles = referral.items?.filter(i => i.item_type === 'profile') || [];
  const tests    = referral.items?.filter(i => i.item_type === 'test')    || [];
  const hasReport = !!referral.results_pdf_path;
  // Keep the panel reachable once a report exists, whatever the status has moved on
  // to (sent, cancelled) — otherwise there is no way back in to view or replace it.
  const showUploadPanel = status === 'results_received' || hasReport;

  return (
    <div className="ris-radiology-exam-detail">
      <button onClick={onBack} className="ris-radiology-back-button">← Back to Referrals</button>
      <h3>
        Lab Referral #{referral.id} — {referral.first_name} {referral.last_name}
        <AbnormalFlag status={referral.abnormal_status} abnormal={referral.abnormal} />
      </h3>
      <div className="ris-radiology-form-group">
        <label>Accession:</label>
        <AccessionTag type="referral" id={referral.id} style={{ fontSize: '1.1em' }} />
      </div>

      <div className="ris-radiology-exam-info">
        {/* Patient */}
        <h4>Patient Information</h4>
        <div className="ris-radiology-form-group">
          <label>Name:</label>
          <span>{referral.first_name} {referral.last_name}</span>
        </div>
        <div className="ris-radiology-form-group">
          <label>DOB:</label>
          <span>{referral.dob || 'N/A'}</span>
        </div>
        <div className="ris-radiology-form-group">
          <label>Sex:</label>
          <span>{referral.sex || 'N/A'}</span>
        </div>

        {/* Order */}
        <h4 style={{ marginTop: '16px' }}>Order Details</h4>
        <div className="ris-radiology-form-group">
          <label>Ordering Clinician:</label>
          <span>{referral.ordering_clinician}</span>
        </div>
        <div className="ris-radiology-form-group">
          <label>Diagnosis:</label>
          <span>{referral.diagnosis}</span>
        </div>
        <div className="ris-radiology-form-group">
          <label>Referred To:</label>
          <span>{referral.referred_to}</span>
        </div>
        <div className="ris-radiology-form-group">
          <label>Billing:</label>
          <span>{referral.billing_type === 'client_bill' ? 'Client Bill — Do not bill Insurance' : 'Insurance'}</span>
        </div>
        <div className="ris-radiology-form-group">
          <label>Specimen Date:</label>
          <span>{referral.specimen_date ? formatAppointmentDate(referral.specimen_date) : 'N/A'}</span>
        </div>
        <div className="ris-radiology-form-group">
          <label>Specimen Time:</label>
          <span>{referral.specimen_time || 'N/A'}</span>
        </div>
        <div className="ris-radiology-form-group">
          <label>Drawn By:</label>
          <span>{referral.drawn_by || 'N/A'}</span>
        </div>
        <div className="ris-radiology-form-group">
          <label>Fasting:</label>
          <span>{referral.fasting || 'N/A'}</span>
        </div>
        <div className="ris-radiology-form-group">
          <label>Priority:</label>
          <span style={{ color: referral.priority === 'STAT' ? '#ef4444' : 'inherit', fontWeight: referral.priority === 'STAT' ? 700 : 400 }}>
            {referral.priority}
          </span>
        </div>
        {referral.notes && (
          <div className="ris-radiology-form-group">
            <label>Notes:</label>
            <span>{referral.notes}</span>
          </div>
        )}

        {/* Status update */}
        <div className="ris-radiology-form-group" style={{ marginTop: '16px' }}>
          <label>Status:</label>
          <select value={status} onChange={e => setStatus(e.target.value)}>
            <option value="pending">Pending</option>
            <option value="results_received">Results Received</option>
            <option value="sent">Sent</option>
            <option value="cancelled">Cancelled</option>
          </select>
        </div>
        <button className="ris-bigger-blue-button" onClick={saveStatus} disabled={saving}>
          {saving ? 'Saving…' : 'Save Status'}
        </button>

        {/* Results entry — visible once status is Results Received, or whenever a
            report is on file so it can be viewed and replaced later */}
        {showUploadPanel && (
          <div style={{ marginTop: '24px', padding: '16px', background: '#f0fdf4', border: '1px solid #86efac', borderRadius: '8px' }}>
            <h4 style={{ marginTop: 0, marginBottom: '12px', color: '#166534' }}>Lab Results</h4>
            {hasReport && !replacing ? (
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                <span style={{ fontSize: '14px', color: '#166534' }}>Report on file.</span>
                <button className="ris-bigger-blue-button" onClick={openReportModal}>View Report</button>
                <button
                  className="ris-modal-btn-replace"
                  onClick={() => { setResultRows([{ ...EMPTY_ROW }]); setGenerateMsg(''); setReplacing(true); }}
                >
                  Replace Results
                </button>
                {referral.validated_at && (
                  <span className="ris-validation-badge ris-validation-badge-pass">Validated</span>
                )}
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {/* Replacing an existing report — the new one supersedes it outright */}
                {hasReport && (
                  <div style={{ padding: '10px 12px', background: '#fef3c7', border: '1px solid #fcd34d', borderRadius: '6px', fontSize: '13px', color: '#92400e' }}>
                    Replacing results — generating a new report will supersede the report currently
                    on file and clear its validation.
                  </div>
                )}

                {/* Structured results entry — one analyte per row */}
                <div>
                  <label style={{ display: 'block', fontWeight: 600, fontSize: '13px', color: '#166534', marginBottom: '6px' }}>
                    Results — one analyte per row
                  </label>
                  <ResultRowsEditor
                    rows={resultRows}
                    onChange={(next) => { setResultRows(next); setGenerateMsg(''); }}
                    disabled={generating}
                  />
                </div>

                {/* Reference range checkboxes */}
                {Object.keys(referralRanges).length > 0 && (
                  <div>
                    <p style={{ fontWeight: 600, fontSize: '13px', color: '#166534', marginBottom: '8px' }}>
                      Reference Ranges — check applicable ranges to include in report:
                    </p>
                    {(referral.items || [])
                      .filter((item, idx, arr) => item.cpt_code && arr.findIndex(i => i.cpt_code === item.cpt_code) === idx)
                      .map(item => {
                        const ref = referralRanges[item.cpt_code];
                        if (!ref || !ref.rows) return null;
                        return (
                          <div key={item.cpt_code} style={{ marginBottom: '10px', padding: '10px 12px', background: '#fff', border: '1px solid #86efac', borderRadius: '6px' }}>
                            <p style={{ fontWeight: 600, fontSize: '12px', color: '#0e8a8f', marginBottom: '6px' }}>
                              {ref.name}{ref.unit ? ` (${ref.unit})` : ''}
                            </p>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                              {ref.rows.map(([label, range], idx) => (
                                <label key={idx} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '12px', cursor: 'pointer', color: '#374151' }}>
                                  <input
                                    type="checkbox"
                                    checked={!!checkedRanges[`${item.cpt_code}_${idx}`]}
                                    onChange={() => toggleCheck(item.cpt_code, idx)}
                                    disabled={generating}
                                    style={{ width: '14px', height: '14px', cursor: 'pointer' }}
                                  />
                                  <span style={{ flex: 1 }}>{label}</span>
                                  <span style={{ color: '#6b7280', minWidth: '120px', textAlign: 'right' }}>{range}</span>
                                </label>
                              ))}
                            </div>
                            {ref.note && <p style={{ fontSize: '11px', color: '#9ca3af', marginTop: '4px' }}>* {ref.note}</p>}
                          </div>
                        );
                      })}
                  </div>
                )}

                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <button
                    className="ris-bigger-blue-button"
                    onClick={generateReport}
                    disabled={filledRows.length === 0 || generating}
                  >
                    {generating ? 'Generating Report…' : hasReport ? 'Generate Replacement Report' : 'Generate Report'}
                  </button>
                  {hasReport && (
                    <button
                      className="pdfViewer-close-button"
                      disabled={generating}
                      onClick={() => { setReplacing(false); setResultRows([{ ...EMPTY_ROW }]); setGenerateMsg(''); }}
                    >
                      Cancel
                    </button>
                  )}
                  {generateMsg && (
                    <span style={{ fontSize: '13px', color: generateMsg.startsWith('Error') ? '#dc2626' : '#166534' }}>
                      {generateMsg}
                    </span>
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {/* Items */}
        {profiles.length > 0 && (
          <>
            <h4 style={{ marginTop: '20px' }}>Profiles Ordered</h4>
            <ul style={{ marginLeft: '16px' }}>
              {profiles.map(p => (
                <li key={p.id}>{p.item_name}{p.cpt_code ? ` — CPT: ${p.cpt_code}` : ''}</li>
              ))}
            </ul>
          </>
        )}
        {tests.length > 0 && (
          <>
            <h4 style={{ marginTop: '16px' }}>Tests Ordered</h4>
            <ul style={{ marginLeft: '16px' }}>
              {tests.map(t => (
                <li key={t.id}>{t.item_name}{t.cpt_code ? ` — CPT: ${t.cpt_code}` : ''}</li>
              ))}
            </ul>
          </>
        )}
      </div>

      {/* ── Report viewer modal ─────────────────────────────────────────── */}
      {reportModal && (
        <div className="pdfViewer-modal-overlay open">
          <div className="pdfViewer-modal-content">
            <div className="pdfViewer-modal-header">
              <h3>Lab Referral Report #{referral.id} — {referral.first_name} {referral.last_name}</h3>
              <p className="pdfViewer-modal-subtitle">{referral.diagnosis}</p>
            </div>

            <div style={{ flex: 1, overflow: 'hidden', minHeight: 0 }}>
              {reportLoading ? (
                <p style={{ padding: '20px', textAlign: 'center' }}>Loading report…</p>
              ) : reportPdfUrl ? (
                <iframe
                  src={reportPdfUrl}
                  title="Lab Referral Report"
                  width="100%"
                  height="100%"
                  className="pdfViewer-modal-element"
                  style={{ border: 'none', display: 'block' }}
                />
              ) : (
                <p style={{ padding: '20px', textAlign: 'center', color: '#dc2626' }}>
                  Failed to load report. Please try again.
                </p>
              )}
            </div>

            <div className="pdfViewer-modal-footer" style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
              {/* Replace Results */}
              <button
                className="ris-modal-btn-replace"
                onClick={() => {
                  setReportModal(false);
                  setReportPdfUrl(null);
                  setResultRows([{ ...EMPTY_ROW }]);
                  setGenerateMsg('');
                  setReplacing(true);
                }}
              >
                Replace Results
              </button>

              {/* Validate — opens validation modal and runs AI check */}
              <button
                className="ris-modal-btn-validate"
                onClick={() => { setValidationModal(true); runValidation(false); }}
              >
                Validate
              </button>

              {/* Send as Fax — disabled until validation has been run */}
              <button
                className="ris-modal-btn-fax"
                disabled={!referral.validated_at}
                title={!referral.validated_at ? 'Complete validation before sending as fax' : 'Send results by fax'}
                onClick={() => setFaxModal(true)}
              >
                Send as Fax
              </button>

              <button
                className="pdfViewer-close-button"
                onClick={() => { setReportModal(false); setReportPdfUrl(null); }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Validation modal ────────────────────────────────────────────── */}
      {validationModal && (
        <div className="pdfViewer-modal-overlay open" style={{ zIndex: 1200 }}>
          <div
            className="pdfViewer-modal-content"
            style={{ width: '520px', height: 'auto', maxWidth: '92vw', padding: '0' }}
          >
            <div className="pdfViewer-modal-header">
              <h3>AI Validation</h3>
              <p className="pdfViewer-modal-subtitle">
                Referral #{referral.id} — {referral.first_name} {referral.last_name}
              </p>
            </div>

            <div style={{ padding: '20px 24px' }}>
              {validationLoading && (
                <div className="ris-validation-loading">
                  <GearsSpinner alt="Validating…" />
                  <p>Analyzing document…</p>
                </div>
              )}

              {!validationLoading && validationError && (
                <>
                  <div className="ris-validation-error">
                    {validationError}
                  </div>
                  <button
                    className="ris-manual-validate-btn"
                    onClick={() => runValidation(true)}
                  >
                    Unable to reach AI — Mark as Manually Validated
                  </button>
                </>
              )}

              {!validationLoading && validationResult && (
                <div className="ris-validation-cards">
                  {/* Name Check */}
                  <div className="ris-validation-card">
                    <div className="ris-validation-card-header">
                      <span className="ris-validation-card-title">Name Check</span>
                      <span className={`ris-validation-badge ${validationResult.name_check?.pass ? 'ris-validation-badge-pass' : 'ris-validation-badge-fail'}`}>
                        {validationResult.name_check?.pass ? 'Pass' : 'Fail'}
                      </span>
                    </div>
                    <div className="ris-validation-card-body">
                      {validationResult.name_check?.found_name && (
                        <div className="ris-validation-row">
                          <span className="ris-validation-label">Name found:</span>
                          <span className="ris-validation-value">{validationResult.name_check.found_name}</span>
                        </div>
                      )}
                      {validationResult.name_check?.found_dob && (
                        <div className="ris-validation-row">
                          <span className="ris-validation-label">DOB found:</span>
                          <span className="ris-validation-value">{validationResult.name_check.found_dob}</span>
                        </div>
                      )}
                      {validationResult.name_check?.found_age && (
                        <div className="ris-validation-row">
                          <span className="ris-validation-label">Age found:</span>
                          <span className="ris-validation-value">{validationResult.name_check.found_age}</span>
                        </div>
                      )}
                      {validationResult.name_check?.details && (
                        <p className="ris-validation-details">{validationResult.name_check.details}</p>
                      )}
                    </div>
                  </div>

                  {/* Order Check */}
                  <div className="ris-validation-card">
                    <div className="ris-validation-card-header">
                      <span className="ris-validation-card-title">Order Check</span>
                      <span className={`ris-validation-badge ${validationResult.order_check?.pass ? 'ris-validation-badge-pass' : 'ris-validation-badge-fail'}`}>
                        {validationResult.order_check?.pass ? 'Pass' : 'Fail'}
                      </span>
                    </div>
                    <div className="ris-validation-card-body">
                      {validationResult.order_check?.found_tests?.length > 0 && (
                        <div className="ris-validation-row">
                          <span className="ris-validation-label">Tests found:</span>
                          <span className="ris-validation-value">{validationResult.order_check.found_tests.join(', ')}</span>
                        </div>
                      )}
                      {validationResult.order_check?.details && (
                        <p className="ris-validation-details">{validationResult.order_check.details}</p>
                      )}
                    </div>
                  </div>

                  {/* Manual badge if this was a staff override */}
                  {validationResult.manual && (
                    <p style={{ textAlign: 'center', margin: 0 }}>
                      <span className="ris-validation-badge ris-validation-badge-manual">Manually Validated</span>
                    </p>
                  )}
                </div>
              )}
            </div>

            <div className="pdfViewer-modal-footer">
              <button
                className="pdfViewer-close-button"
                onClick={() => { setValidationModal(false); setValidationResult(null); setValidationError(null); }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Fax number modal ────────────────────────────────────────────── */}
      {faxModal && (
        <div className="pdfViewer-modal-overlay open" style={{ zIndex: 1100 }}>
          <div
            className="pdfViewer-modal-content"
            style={{ width: '420px', height: 'auto', maxWidth: '90vw', padding: '24px' }}
          >
            <div className="pdfViewer-modal-header">
              <h3>Send Results by Fax</h3>
              <p className="pdfViewer-modal-subtitle">
                Enter the recipient fax number for {referral.first_name} {referral.last_name}'s lab results.
              </p>
            </div>

            <div style={{ padding: '20px 0 8px' }}>
              <label style={{ display: 'block', fontWeight: 600, marginBottom: '8px', fontSize: '14px', color: '#374151' }}>
                Fax Number
              </label>
              <InputMask
                mask="(XXX) XXX-XXXX"
                replacement={{ X: /\d/ }}
                type="tel"
                placeholder="(555) 555-5555"
                value={faxNumber}
                onChange={e => setFaxNumber(e.target.value)}
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '15px',
                  boxSizing: 'border-box',
                }}
              />
            </div>

            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', paddingTop: '12px' }}>
              <button
                className="pdfViewer-close-button"
                onClick={() => { setFaxModal(false); setFaxNumber(''); }}
              >
                Cancel
              </button>
              <button
                className="ris-bigger-blue-button"
                disabled={!faxNumber.trim()}
                onClick={() => {
                  // TODO: wire up fax sending
                  setFaxModal(false);
                  setFaxNumber('');
                }}
              >
                Send Fax
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const LabSection = () => {
  const [activeTab, setActiveTab] = useState('schedule');
  const [selectedExamId, setSelectedExamId] = useState(null);
  const [selectedReferralId, setSelectedReferralId] = useState(null);

  return (
    <div className="labs-page">
      <ToastContainer />
      <PageTopBar links={[
        { label: 'Home', to: '/home', icon: Home },
        { label: 'Radiology', to: '/radiology', icon: Aperture },
        { label: 'Results', to: '/results', icon: FileCheck },
      ]} />
      <div className="labs-content">
      <div className="ris-lab-section">
        <div className="ris-lab-header">
          <h2>Labs Section</h2>
        </div>

        {selectedReferralId ? (
          <ReferralDetail referralId={selectedReferralId} onBack={() => setSelectedReferralId(null)} />
        ) : selectedExamId ? (
          <ExamDetail examId={selectedExamId} onBack={() => setSelectedExamId(null)} />
        ) : (
          <>
            <div className="ris-radiology-tabs">
              <button
                className={activeTab === 'schedule' ? 'active' : ''}
                onClick={() => setActiveTab('schedule')}
              >
                Schedule
              </button>
              <button
                className={activeTab === 'examStatus' ? 'active' : ''}
                onClick={() => setActiveTab('examStatus')}
              >
                Exam Status
              </button>
              <button
                className={activeTab === 'referrals' ? 'active' : ''}
                onClick={() => setActiveTab('referrals')}
              >
                Referrals
              </button>
            </div>
            {activeTab === 'schedule'   && <Schedule onSelectExam={setSelectedExamId} />}
            {activeTab === 'examStatus' && <ExamStatus onSelectExam={setSelectedExamId} />}
            {activeTab === 'referrals'  && <ReferralList onSelectReferral={setSelectedReferralId} />}
          </>
        )}
        

        
        
      </div>
      </div>
    </div>
  );

};

export default LabSection;